export const routes = [
  {
    path: "/municipio-escola",
    component: () =>
      import(/* webpackChunkName: "evidence" */ "./municipio/List"),
    name: "municipio.escola",
    meta: {
      requiresAuth: true,
    },
  },
];
